var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('NavBar',{attrs:{"quantityInmobByDistrict":_vm.quantityInmobByDistrict,"prices":_vm.prices,"loading":_vm.loading}}),_c('router-view'),_c('v-divider'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }